import { Link } from "react-router-dom";

export const LogoMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="32" height="64" fill="#0B0C0E" />
    <rect x="32" width="32" height="64" fill="#F4EFE6" />
    <polygon points="9,54 25,10 32,10 32,24 19,54" fill="#F4EFE6" />
    <line x1="32" y1="10" x2="54" y2="54" stroke="#14213A" strokeWidth="2.4" />
    <rect x="18" y="38" width="14" height="5" fill="#F4EFE6" />
    <line x1="32" y1="40.5" x2="45" y2="40.5" stroke="#14213A" strokeWidth="1.6" />
    <circle cx="32" cy="10" r="2.2" fill="#B08D57" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group">
    <span className="transition-transform duration-500 group-hover:rotate-[8deg]"><LogoMark /></span>
    <span className="f-wordmark text-[15px] tracking-[0.42em]">ANVOCRA</span>
  </Link>
);
